<template>
  <div class="form-group vue-slider-container" :class="{'input-box': showInputBox}">

    <span class="form-group">
      <label :class="{ 'text-danger': hasErrors(getFieldName) }"> {{label}} </label>
      <comments v-if="addComment" :field-name="getCommentfieldName" :model-name="modelName"></comments>
      <br>
      <small class="form-text text-muted" v-if="subtext">
        {{subtext}}
      </small>
    </span>

    <vue-slider v-model="inputVal"
                :lazy="true"
                :interval="5"
                @change="emitChange"
                :disabled="isReadOnly"/>

    <span v-show="errors.has(getFieldName)" class="text-danger">{{ errors.first(getFieldName) }}</span>

    <div v-show="hasErrors(getFieldName)">
      <span v-for="(error, index) in errorsFor(getFieldName)" class="text-danger" :key="`error_${getFieldName}_${index}`">
        {{error}}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Comments from '@/components/Comments'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'SliderInput',
  inheritAttrs: false,
  props: {
    fieldName: String,
    commentFieldName: String,
    label: String,
    subtext: String,
    addComment: Boolean,
    addEmailNotification: Boolean,
    disabled: Boolean,
    modelName: String,
    vvalidate: String,
    showInputBox: {type: Boolean, default: true}
  },
  components: {
    Comments,
    VueSlider,
  },
  methods: {
    emitChange: function ()
    {
      this.$emit('change')
    }
  },
  computed: {
    ...mapGetters('currentConsult', ['hasErrors', 'errorsFor', 'isReadOnly', 'getFieldValue']),
    getCommentfieldName() {
      return this.commentFieldName ? this.commentFieldName : this.fieldName
    },
    inputVal: {
      get() {
        return this.getFieldValue(this.getFieldName, this.modelName)
      },
      set(val) {
        let payload = {fieldName: this.getFieldName, value: val, modelName: this.modelName}

        this.$store.dispatch('currentConsult/setFieldValue', payload)
        this.$emit('on-change', payload)
      }
    }
  }
}
</script>

<style scoped>
i {
  margin-right: 0.5em;
}
.vue-slider-container {
  padding-top: 9px;
  padding-bottom: 9px;
}
</style>
